// Copyright (c) 2019 embyt GmbH. All rights reserved.
// Author: Roman Morawek

import * as React from "react";
import { connect } from "react-redux";
import { FormattedMessage, MessageDescriptor, IntlContext, IntlShape } from "react-intl";

import { IState } from "states/states";

import { DataState } from "types";
import { Button } from "react-bootstrap";

import SvgEyeOff from "icons/iconEyeOff";
import SvgEyeOn from "icons/iconEyeOn";
import { isSet } from "shared/utils/utils";

import "./InputField.scss";

export enum eInputFieldType {
  Text,
  Password,
}

interface IInputFieldExtProps {
  inputType: eInputFieldType;
  // unique field identifier; falls back to a generic name based on inputType when omitted,
  // which is only safe when a form has at most one field of that inputType
  name?: string;
  // id of the <input>, so a caller can point a <label htmlFor> at it; falls back to `name`
  id?: string;
  errorText?: string;
  value: string;
  dataState: DataState;
  placeholder?: MessageDescriptor;
  title?: MessageDescriptor;
  autoComplete?: string;
  autoFocus?: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

interface IInputFieldState {
  showContent: boolean;
}

interface IInputFieldProps {}

const mapStateToProps = (state: IState, ownProps: IInputFieldExtProps) => {
  const props: IInputFieldProps = {};
  return props;
};

class InputFieldComponent extends React.Component<
  IInputFieldProps & IInputFieldExtProps,
  IInputFieldState
> {
  static contextType = IntlContext;
  declare context: IntlShape;

  state: IInputFieldState = {
    showContent: this.props.inputType !== eInputFieldType.Password,
  };

  public render() {
    const fieldName =
      this.props.name ??
      (this.props.inputType === eInputFieldType.Password ? "password" : "username");
    const fieldId = this.props.id ?? fieldName;
    const hasError = isSet(this.props.errorText) && this.props.errorText !== "";
    const errorId = `${fieldId}-error`;

    return (
      <div className="mb-3 position-relative">
        <input
          id={fieldId}
          autoFocus={this.props.autoFocus}
          autoComplete={this.props.autoComplete}
          placeholder={
            isSet(this.props.placeholder) ?
              this.context.formatMessage(this.props.placeholder)
            : undefined
          }
          name={fieldName}
          type={this.state.showContent ? "text" : "password"}
          className={`inputFieldControl${hasError ? " input-error" : ""}`}
          value={this.props.value}
          title={isSet(this.props.title) ? this.context.formatMessage(this.props.title) : undefined}
          disabled={this.props.dataState === DataState.SAVE_REQ}
          aria-invalid={hasError || undefined}
          aria-describedby={hasError ? errorId : undefined}
          onChange={(event) => {
            this.props.onChange(event);
          }}
        />
        {this.props.inputType === eInputFieldType.Password && (
          <Button
            type="button"
            className="position-absolute bg-transparent border-0"
            tabIndex={-1}
            style={{
              right: 10,
            }}
            onClick={() => this.executeIconTap()}
          >
            {this.renderIcon()}
          </Button>
        )}

        {hasError && (
          <div id={errorId} className="loginError mt-1">
            <FormattedMessage id={this.props.errorText}></FormattedMessage>
          </div>
        )}
      </div>
    );
  }

  private executeIconTap() {
    switch (this.props.inputType) {
      case eInputFieldType.Password:
        this.setState({ showContent: !this.state.showContent });
        break;
      case eInputFieldType.Text:
        break;
    }
  }

  private renderIcon() {
    switch (this.props.inputType) {
      case eInputFieldType.Password:
        return this.state.showContent ? <SvgEyeOff /> : <SvgEyeOn />;
      case eInputFieldType.Text:
        return <></>;
    }
  }
}

export default connect(mapStateToProps)(InputFieldComponent);
